import { CheckCircle2, Landmark, Phone, MessageSquareText } from "lucide-react";
import { IMAGES, CONTACT, openChat } from "@/config/site";
import { Reveal } from "./Motion";

const STEPS = ["Online Registration", "Documents & Approval", "Installation", "Subsidy Claim Support"];

export const PMSuryaGhar = () => (
  <section id="pm-yojana" data-testid="pm-surya-ghar-section" className="section-pad relative">
    <div className="container-x">
      <Reveal>
        <div className="relative overflow-hidden rounded-[2rem] border border-gold/30 bg-white shadow-[0_30px_80px_-30px_rgba(217,119,6,0.35)]">
          <div className="grid lg:grid-cols-2">
            <div className="relative z-10 p-7 sm:p-12 lg:p-14">
              <div className="inline-flex items-center gap-2 rounded-full bg-gold/15 px-4 py-2 text-sm font-semibold text-gold-ink">
                <Landmark className="h-4 w-4" /> PM Surya Ghar Muft Bijli Yojana
              </div>
              <h2 className="font-display mt-6 text-3xl sm:text-4xl lg:text-5xl font-bold leading-[1.15] text-navy-900">
                Rooftop Solar with <span className="text-gold-gradient">Government Subsidy</span>
              </h2>
              <div data-testid="pm-subsidy-note" className="glass mt-6 rounded-2xl p-5 text-lg text-slate-800">
                Government subsidy available — call us for details.
              </div>
              <p className="mt-8 font-display text-xl font-semibold text-navy-900">We handle the complete process</p>
              <ul className="mt-4 grid gap-3 sm:grid-cols-2">
                {STEPS.map((s) => (
                  <li key={s} className="flex items-center gap-3 text-[17px] text-slate-700">
                    <CheckCircle2 className="h-6 w-6 shrink-0 text-emerald-700" /> {s}
                  </li>
                ))}
              </ul>
              <div className="mt-9 flex flex-col sm:flex-row gap-3">
                <button onClick={openChat} data-testid="pm-apply-button" className="btn-gold h-14 px-7 text-lg">
                  <MessageSquareText className="h-5 w-5" /> Get Scheme Details
                </button>
                <a href={CONTACT.tel} data-testid="pm-call-button" className="btn-ghost h-14 px-7 text-lg">
                  <Phone className="h-5 w-5" /> Call करें
                </a>
              </div>
            </div>
            <div className="relative min-h-[280px] lg:min-h-full">
              <img src={IMAGES.pmFamily} alt="Happy Indian family on rooftop with solar panels" loading="lazy" className="absolute inset-0 h-full w-full object-cover" />
            </div>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
